import React from "react";
import Routers from "./Components/Routers/Routers";
import AuthButton from "./AuthButton";
import { connect } from "react-redux";

function App({ UserId, userType }) {
  if (!UserId || !userType) {
    return <AuthButton />;
  }
  return <Routers />;
}

const mapStateToProps = (state) => {
  return {
    menuVisibility: state.menuVisibility,
    menuStatusHeader: state.menuStatusHeader,
    getToken: state.token,
    userType: state.userType,
    userName: state.userName,
    UserId: state.UserId,
  };
};

export default connect(mapStateToProps)(App);
